import { useContext } from 'react'

import { LoadingContext } from './LoadingContext'

export function useLoading() {
  const value = useContext(LoadingContext)
  if (!value) {
    throw new Error('useLoading must be used inside LoadingProvider')
  }
  return value
}
